import React from 'react'
import BrandServices from './BrandServices/BrandServices'
import OurServices from './OurServices/OurServices'
import WhatWeDo from './WhatWeDo/WhatWeDo'
import WorkProcess from './WorkProcess/WorkProcess'

const Service = () => {
  return (
    <div style={{background:"white"}}>


        <BrandServices/>
        <OurServices/>
        <div style={{background:"white"}}>

        <WhatWeDo/>
        </div>
        <WorkProcess/>
    </div>
  )
}

export default Service